import LoaderSpinner from './LoaderSpinner';

export default LoaderSpinner;
